@if (show()) {
  <kendo-dialog
    [title]="titleTextSignal()"
    [maxWidth]="400"
    [minWidth]="250"
    (close)="onCancel()"
  >
    @if (bodyTemplateSignal()) {
      <ng-container *ngTemplateOutlet="bodyTemplateSignal()"></ng-container>
    } @else {
      <div help-anchor="confirmDialogMessage">
        {{ messageSignal() }}
      </div>
    }
    <kendo-dialog-actions>
      <button
        class="k-button"
        (click)="onCancel()"
        help-anchor="confirmDialogCancelBtn"
      >
        {{ cancelTextSignal() }}
      </button>
      <button
        help-anchor="confirmDialogConfirmBtn"
        class="k-button k-primary"
        (click)="onConfirm()"
        primary="true"
      >
        {{ confirmTextSignal() }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
